<div #tooltipbox class="tooltip-wrapper" *ngIf="isVisible" [style]="customStyle">
    <div class="image-wrapper" *ngIf="options?.imagePath">
        <img src="{{options.imagePath}}" alt="Tooltip related image">
    </div>
    <div class="description-wrapper" *ngIf="options?.textDescription">
        <span>{{options.textDescription}}</span>
    </div>
</div>